export function Spinner({ label = 'Loading' }: { label?: string }): JSX.Element {
  return (
    <div className="flex items-center gap-3 text-slate-500" role="status" aria-live="polite">
      <span
        className="h-5 w-5 animate-spin rounded-full border-2 border-slate-300 border-t-brand"
        aria-hidden="true"
      />
      <span className="text-sm">{label}…</span>
    </div>
  );
}
